"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.humanizeValue = void 0;
const humanize_type_1 = require("./humanize-type");
const humanize_values_1 = require("./humanize-values");
const vowels = ["a", "e", "i", "o", "u"];
/**
 * Convert any value to a short, human-readable string
 */
function humanizeValue(value, options = {}) {
    let type = typeof value;
    let str = String(value);
    let canHavArticle = true;
    let article = options.article;
    let capitalize = options.capitalize;
    let maxLength = options.maxLength || 25;
    if (value === null) {
        return capitalize ? "Null" : "null";
    }
    else if (value === undefined) {
        return capitalize ? "Undefined" : "undefined";
    }
    else if (type === "string") {
        if (str.length > maxLength) {
            return `"${str.slice(0, maxLength - 3)}..."`;
        }
        return `"${str}"`;
    }
    else if (Number.isNaN(value)) {
        return "NaN";
    }
    else if (str.length > 0 && Array.isArray(value)) {
        str = `[${str}]`;
    }
    if (type === "object") {
        if (str.length > 0 && str.length <= maxLength && !str.startsWith("[object ")) {
            canHavArticle = false;
        }
        else {
            str = humanize_type_1.humanizeType(value);
            if (str === "Object") {
                let keys = Object.keys(value);
                if (keys.length === 0) {
                    str = "{}";
                    canHavArticle = false;
                }
                else {
                    str = `{${humanize_values_1.humanizeList(keys, { maxLength, conjunction: false })}}`;
                    canHavArticle = false;
                }
            }
        }
    }
    else if (str.length > 0 && str.length <= maxLength) {
        switch (type) {
            case "number":
            case "bigint":
            case "function":
                return str;
            case "boolean":
                canHavArticle = false;
        }
    }
    else {
        str = type;
    }
    if (article && canHavArticle) {
        let firstLetter = str[0].toLowerCase();
        if (vowels.includes(firstLetter)) {
            str = `an ${str}`;
        }
        else {
            str = `a ${str}`;
        }
    }
    if (capitalize) {
        str = str[0].toUpperCase() + str.slice(1);
    }
    return str;
}
exports.humanizeValue = humanizeValue;
//# sourceMappingURL=humanize-value.js.map